<div class="sdps-navigation--horizontal">
  <nav class="sdps-navigation--horizontal__levelThree" aria-label="Primary navigation">
    <ul class="sdps-navigation--horizontal__list">
      <ng-container *ngFor="let item of menuList;">
        <li class="sdps-navigation--horizontal__item" routerLinkActive="sdps-is-active" [ngClass]="!item.showLink ? 'demo-border-bottom':''">
          <a class="sdps-navigation--horizontal__link" *ngIf="item.showLink && this.sharedService.checkAccess(item.accessName) && !(item.accessName === 'admin' && sharedService.showHistoricalView.value)" >
            <button [id]="item.routerLink" class="buttons navigation-button" [routerLink]="item.routerLink"
                  [innerHTML]="item.menuName" (click)="sharedService.loadDataTrackValue(item.routerLink)"></button>
          </a>
          <a class="sdps-navigation--horizontal__link" *ngIf="!item.showLink && !item.hideTab && this.sharedService.checkAccess(item.accessName)" [class.ui-disable-nav-tab]="!item.showLink ? true: ''"
            [innerHTML]="item.menuName" [title]="shellConstant.accessDeniedTooltipMessage"></a>
        </li>
      </ng-container>
    </ul>
  </nav>
</div>
